import { format } from "date-fns";
import { MapPin, Calendar, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import type { CommunityEvent } from "@/types/eventPartner";

interface EventCardProps {
  event: CommunityEvent;
  onClick: () => void;
  isSelected?: boolean;
}

export const EventCard = ({ event, onClick, isSelected }: EventCardProps) => {
  const eventDate = new Date(event.starts_at);
  const formattedDate = format(eventDate, "MMM d, yyyy 'at' h:mm a");

  return (
    <Card
      className={`cursor-pointer transition-all hover:border-primary/50 ${
        isSelected ? "border-primary ring-1 ring-primary" : ""
      }`}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            {/* Event Image */}
            {event.image && (
              <div className="mb-3 rounded-lg overflow-hidden h-32 bg-muted">
                <img
                  src={event.image}
                  alt={event.name}
                  className="w-full h-full object-cover"
                />
              </div>
            )}

            {/* Event Name */}
            <h3 className="font-semibold text-lg text-foreground truncate">
              {event.name}
            </h3>

            {/* Venue */}
            <div className="flex items-center gap-1.5 mt-2 text-muted-foreground">
              <MapPin className="h-4 w-4 flex-shrink-0" />
              <span className="text-sm truncate">{event.venue_name}</span>
            </div>

            {/* Date */}
            <div className="flex items-center gap-1.5 mt-1 text-muted-foreground">
              <Calendar className="h-4 w-4 flex-shrink-0" />
              <span className="text-sm">{formattedDate}</span>
            </div>
          </div>

          <ChevronRight className="h-5 w-5 text-muted-foreground flex-shrink-0 ml-2" />
        </div>
      </CardContent>
    </Card>
  );
};
